// extracted by mini-css-extract-plugin
export default {"container":"styles_container__z-vqb","success":"styles_success__KYUa+","error":"styles_error__OZ+MI","closeIcon":"styles_closeIcon__ZqwYW"};